import env from "@shared/api/env";
import { supabase } from "@shared/api/supabase";

/** Include apikey + bearer for PostgREST calls protected by RLS. */
export async function getSupabaseAuthHeaders(): Promise<Record<string, string>> {
  // Avoid hanging indefinitely if the SDK stalls; fall back to anon-only quickly.
  let session: { access_token?: string } | null = null;
  try {
    const result = (await Promise.race([
      supabase.auth.getSession(),
      new Promise((resolve) => setTimeout(() => resolve(undefined), 2000)),
    ])) as any;
    session = result?.data?.session ?? null;
  } catch {
    // ignore; use anon only
  }
  const headers: Record<string, string> = { apikey: env.SUPABASE_ANON_KEY };
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  return headers;
}
